import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/@ant-design+nextjs-registry@1.1.0_@ant-design+cssinjs@1.24.0_react-dom@18.3.1_react@18._b5b9d80a7cdb8ffd94aa8e8f02631e36/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/src/components/home/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileDetector"] */ "/app/src/components/mobile-detector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThirdPartyAuthHandler"] */ "/app/src/components/third-party-auth-handler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/src/components/ui/error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/diff-preview-override.css");
